// Mixin for checking expiration date, and set counter
import { mapGetters, mapState, mapActions } from 'vuex';
import StructCaller from '@/helpers/structInterface';
import humanizeDuration from 'humanize-duration';
export default {
  data() {
    return {
      timer: null,
      showExpiration: false,
      expires: null,
      expiresDate: null,
      StructCaller,
      humanizeDuration,
    };
  },
  computed: {
    ...mapState(['invoiceInitialData']),
  },
  methods: {
    ...mapActions('UI', ['ADD_MESSAGE']),
    ...mapActions(['setGlobalError']),

    validateDate() {
      const now = new Date();
      // IF unix timestamp, we need * on 1000;

      const passedExpirationDate = new Date(this.invoiceInitialData.expires * 1000);
      this.expiresDate = passedExpirationDate;

      // Check that the date passed from query is valid
      if (Object.prototype.toString.call(passedExpirationDate) === '[object Date]') {
        if (isNaN(passedExpirationDate.getTime())) {
          //  Date is Invalid 👎
          return Promise.reject(this.StructCaller.getStructData('ERRORS', 'code', 'invalid_date'));
        } else {
          const expired = this.checkExpirationDate(this.expiresDate);

          if (expired) {
            // Already expired 👎
            return Promise.reject(
              this.StructCaller.getStructData('ERRORS', 'code', 'invalid_date')
            );
          } else {
            // Valid 👍
            return Promise.resolve({
              type: 'success',
              isValid: true,
            });
          }
        }
      } else {
        // Not a date at all.
        return Promise.reject(this.StructCaller.getStructData('ERRORS', 'code', 'invalid_date'));
      }
    },

    /**
     *  Check that data doesn't expired yet
     */
    checkExpirationDate(expirationDate) {
      const now = new Date();
      const expires = now - expirationDate >= 0;
      return expires;
    },

    humanizeTime(expires) {
      let units = ['d', 'h'];

      const diff = this.$dayjs(expires).diff(new Date());
      //86400000 = one day in ms
      if (diff < 86400000) {
        units = ['h', 'm', 's'];
      }

      const time = this.humanizeDuration(diff <= 0 ? 0 : diff, {
        units: units,
        round: true,
        delimiter: ' ',
        language: this.$i18n.locale,
      });

      return time;
    },

    countDown() {
      const expired = this.checkExpirationDate(this.expiresDate);
      if (!expired) {
        this.expires = this.humanizeTime(this.expiresDate);
      } else {
        clearInterval(this.timer);
        this.setGlobalError({
          code: 'date_expired',
        });
      }
    },
  },
};
